export default "__VITE_ASSET__DhcAqXsL__"